<div class="pt-[125px] md:pt-[145px] lg:pt-[185px] xl:pt-[195px] text-center">
    <div class="container 2xl:max-w-[1320px] mx-auto px-[12px] relative z-[1]">
        <h1 class="!mb-0 !leading-[1.2] !text-3xl md:!text-5xl lg:!text-[50px] xl:!text-[60px] -tracking-[.5px] md:-tracking-[1px] xl:-tracking-[1.5px]">
            <!--i18n - Personal Data Usage Policy -->
            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.title_page' | translate }}
        </h1>
        <div class="absolute bottom-0 -z-[1] ltr:-right-[30px] rtl:-left-[30px] blur-[250px]">
            <img src="images/front-pages/shape3.png" alt="shape3">
        </div>
        <div class="absolute -top-[220px] -z-[1] ltr:-left-[50px] rtl:-right-[50px] blur-[150px]">
            <img src="images/front-pages/shape5.png" alt="shape3">
        </div>
    </div>
</div>

<div class="pb-[60px] md:pb-[80px] lg:pb-[100px] xl:pb-[150px]">
    <div class="container 2xl:max-w-[1320px] mx-auto px-[12px] relative z-[1]">
        <div class="grid grid-cols-1  gap-[25px] items-center">
            <div>
                <ul class="ltr:xl:pl-[18px] rtl:xl:pr-[18px] mt-[25px] md:mt-[30px] lg:mt-[35px] xl:mt-[65px]">
                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[15px] md:!text-md lg:!text-[17px] xl:!text-lg !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n - Identity of the data controller -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.title_01' | translate }}
                        </h3>
                        <p class="!leading-[1.6] text-gray-500">
                            <span>
                                <!--i18n - Data controller: LOOMIS FXGS -->
                                {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.span_01_01' | translate }}
                            </span>
                            <span>
                                <!--i18n - Data controller: Limited Company -->
                                {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.span_01_02' | translate }}
                            </span>
                            <span>
                                <!--i18n - Head office address: 79, rue Benoit MALON – 94250 Gentilly – France -->
                                {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.span_01_03' | translate }}
                            </span>
                            <span>
                                <!--i18n - Capital social : 4.800.000 EUR -->
                                {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.span_01_04' | translate }}
                            </span>
                            <span>
                                <!--i18n - Registered with the Créteil Trade and Companies Register under number: 352 572 937 -->
                                {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.span_01_05' | translate }}
                            </span>
                            <span>
                                <!--i18n - “Site” refers to the following website: www.xxxxxx.fr -->
                                {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.span_01_06' | translate }}
                            </span>
                        </p>
                    </li>
                    
                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[15px] md:!text-md lg:!text-[17px] xl:!text-lg !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                             <!--i18n - Contact details of the Data Protection Officer (DPO) of LOOMIS FXGS -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.title_02' | translate }}
                        </h3>
                        <p class="!leading-[1.6] text-gray-500">
                            <span>
                                <!--i18n - Email address: dpo@fr.loomis.com -->
                                {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.span_02_01' | translate }}
                            </span>
                            <span>
                                <!--i18n - Postal address: DPO Department – ​​Loomis FXGS – 79, rue Benoit MALON – 94250 Gentilly – France -->
                                {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.span_02_02' | translate }}
                            </span>
                        </p>
                    </li>
                    
                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[15px] md:!text-md lg:!text-[17px] xl:!text-lg !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n - Legal basis / Collection / Purposes of processing personal data -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.title_03' | translate }}
                        </h3>
                        <p class="!leading-[1.6] text-gray-500">
                            <!--i18n - LOOMIS FXGS collects and processes your personal data in connection with the provision of foreign currency sales services. -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.p_03_01' | translate }}
                        </p>
                        <p class="!leading-[1.6] text-gray-500">
                            <!--i18n - The purpose of this processing of personal data is to offer this foreign... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.p_03_02' | translate }}
                        </p>
                        <p class="!leading-[1.6] text-gray-500">
                            <!--i18n - The legal bases for this data processing are therefore:... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.p_03_03' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n - The contract (processing necessary for the performance or preparation... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.bp_03_01' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n - The legal obligation (the treatment is imposed by legal texts).... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.bp_03_02' | translate }}
                        </p>
                        <p class="!leading-[1.6] text-gray-500">
                            <!--i18n - Your data is collected directly when you place your order via the information entry forms presented on the Site. -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.p_03_04' | translate }}
                        </p>
                        <p class="!leading-[1.6] text-gray-500">
                            <!--i18n - Regarding the information entry forms displayed on the Site, personal... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.p_03_05' | translate }}
                        </p>
                    </li>

                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[15px] md:!text-md lg:!text-[17px] xl:!text-lg !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n - Legal basis / Collection / Purposes of processing personal data -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.title_08' | translate }}
                        </h3>
                        <p class="!leading-[1.6] text-gray-500">
                            <!--i18n - LOOMIS FXGS collects and processes your personal data in connection with the provision of foreign currency sales services. -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.p_08_01' | translate }}
                        </p>
                        
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n - The contract (processing necessary for the performance or preparation... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.bp_08_01' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n - The legal obligation (the treatment is imposed by legal texts).... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.bp_08_02' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n - The legal obligation (the treatment is imposed by legal texts).... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.bp_08_03' | translate }}
                        </p>
                        
                    </li>


                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[15px] md:!text-md lg:!text-[17px] xl:!text-lg !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n - Cookies -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.title_04' | translate }}
                        </h3>
                        <p class="!leading-[1.6] text-gray-500">
                            <!--i18n - The personal data that is automatically obtained during your connection -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.p_04_01' | translate }}
                        </p>
                    </li>

                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[15px] md:!text-md lg:!text-[17px] xl:!text-lg !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n - Data recipients -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.title_05' | translate }}
                        </h3>
                        <p class="!leading-[1.6] text-gray-500">
                            <!--i18n - All or part of the personal data collected on the Site is communicated to -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.p_05_01' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n - Loomis FXGS (foreign currency sales execution); -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.bp_05_01' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n - Loomis AB (IT infrastructure management); -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.bp_05_02' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n - Loomis Belgium (preparation, transport of documents and incident -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.bp_05_03' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n - Bpost (order placement and delivery of packages); -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.bp_05_04' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n - Lexis Nexis (Sanction screening) ; -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.bp_05_05' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n - STRIPE (payment management). -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.bp_05_06' | translate }}
                        </p>
                    </li>

                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[15px] md:!text-md lg:!text-[17px] xl:!text-lg !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n - Shelf life -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.title_06' | translate }}
                        </h3>
                        <p class="!leading-[1.6] text-gray-500">
                            <!--i18n - LOOMIS FXGS will retain your personal data for a period of six years fro... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.p_06_01' | translate }}
                        </p>
                    </li>

                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[15px] md:!text-md lg:!text-[17px] xl:!text-lg !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n - Exercising the rights of individuals -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.title_07' | translate }}
                        </h3>
                        <p class="!leading-[1.6] text-gray-500">
                            <!--i18n - In accordance with the General Data Protection Regulation No.... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.p_07_01' | translate }}
                        </p>
                        <p class="!leading-[1.6] text-gray-500">
                            <!--i18n - You can exercise these rights by contacting the Data Protection Officer.... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.p_07_02' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n - By email to the following address: dpo@fr.loomis.com -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.bp_07_01' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n - By mail to the following address: DPO Department – ​​Loomis FXGS – 79, -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.bp_07_02' | translate }}
                        </p>
                        <p class="!leading-[1.6] text-gray-500">
                            <!--i18n - Your application must include your full name, email or postal address,.... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.p_07_03' | translate }}
                        </p>
                        <p class="!leading-[1.6] text-gray-500">
                            <!--i18n - If, after contacting our DPO, you believe that your rights have not been -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.p_07_04' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n - Available online at www.cnil.fr -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.bp_07_03' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n - By mail to the following address: CNIL – 3, place de Fontenoy – TSA... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.personal-data-policy.component.bp_07_04' | translate }}
                        </p>
                    </li>
                </ul>
            </div>
        </div>

        <!-- shape :  Tache floue bas droite -->
        <div class="absolute -z-[1] ltr:-right-[30px] rtl:-left-[30px] bottom-[50px] blur-[150px]
                   bg-secondary-400/[0.25] dark:bg-primary-100/[0.25] rounded-full
                   w-[380px] h-[380px]">
        </div>

        <!-- shape : Tache floue haut (remplace shape8) -->
        <div class="absolute -z-[1] ltr:left-[250px] rtl:left-[260px] top-[265px] blur-[175px]
                   bg-secondary-400/[0.25] dark:bg-primary-100/[0.25] rounded-full
                   w-[420px] h-[340px]">
        </div>


        <div class="absolute -top-[60px] ltr:left-[65px] rtl:right-[65px] -z-[1] blur-[150px]">
            <img src="images/front-pages/shape7.png" alt="shape7">
        </div>
        <div class="absolute -bottom-[30px] ltr:right-[20px] rtl:left-[20px] -z-[1] blur-[125px]">
            <img src="images/front-pages/shape8.png" alt="shape8">
        </div>
    </div>
</div>